// Este archivo centraliza los valores constantes que se usan en toda la aplicación.

export const GRADOS = ["Pre-Jardín", "Jardín", "Transición"];

export const DIMENSIONES = [
    "Dimensión Cognitiva", 
    "Dimensión Comunicativa", 
    "Dimensión Socio Afectiva",
    "Dimensión Corporal", 
    "Dimensión Espiritual", 
    "Dimensión Ética y Valores", 
    "Dimensión Estética"
];

export const PERIODOS = [1, 2, 3];

export const VALORACIONES = {
    "EP": "En Proceso",
    "LAA": "Logro Alcanzado con Acompañamiento",
    "LAS": "Logro Alcanzado Satisfactoriamente"
};
